import React from "react";
import OrbitProgress from "react-loading-indicators/OrbitProgress";

const Loading = () => (
  <OrbitProgress variant="track-disc" color="crimson" size="small" />
);

export default Loading;
